import { CardClassKey, StyleRules } from '@material-ui/core';
import { scutiColors, scutiSizes } from './variables';

export const MuiCard: Partial<StyleRules<CardClassKey, {}>> = {
  root: {
    fontSize: scutiSizes.inputFontSize,
    backgroundColor: scutiColors.cardBackground,
  },
};
